import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_61cfca11: FaireBrandEntity = {
  token: "b_61cfca11",
  type: "brand",
  name: "Flora Bunda Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/e0234b849a0f94570c44eaa3bdb4e82b8b74fd66979f68200fb82433fb145d0b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6fd0988053d55e64b7edcb3d2c8b2986f54e00f4f032bbd800492913f8a2dd0c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e0234b849a0f94570c44eaa3bdb4e82b8b74fd66979f68200fb82433fb145d0b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6fd0988053d55e64b7edcb3d2c8b2986f54e00f4f032bbd800492913f8a2dd0c.png",
  location: "RANCHO CUCAMONGA, CA, USA",
  minimumOrderDollars: 137,
  rating: 4.8,
  reviewCount: 257,
  isTopShop: true,
  isInsider: true,
  description:
    "We are your home decor manufacturer, importer and distributor in Rancho Cucamonga, California, serving customers across the globe since 1988. We have design and development teams in the US and every product is manufactured in-house to ensure the best quality and value.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:00.843Z",
    importedBy: "entity-db-cli",
  },
};
